import {
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';
import { uniqWith } from 'lodash';
import { BoardPurchaseFloorCascadableInterface } from '../../board-purchase-floor/interfaces/board-purchase-floor-cascadable.interface';
import { BoardFloorCreatableInterface } from '../interfaces/board-floor-creatable.interface';

interface BoardFloorUniqueValidatorValue
  extends BoardFloorCreatableInterface,
    BoardPurchaseFloorCascadableInterface {}

@ValidatorConstraint({ name: 'boardFloorUnique', async: false })
export class BoardFloorUniqueValidator implements ValidatorConstraintInterface {
  validate(floors: BoardFloorUniqueValidatorValue[]) {
    const uniqFloors = uniqWith(
      floors,
      (
        a: BoardFloorUniqueValidatorValue,
        b: BoardFloorUniqueValidatorValue,
      ) => {
        return a.floor === b.floor && a.boardTypeId === b.boardTypeId;
      },
    );

    return floors.length === uniqFloors.length;
  }

  defaultMessage() {
    return 'Only one board type per floor is allowed.';
  }
}
